import modules from './modules'
import ax from './axios'

const requestFun = async (
  apiUrl,
  postData = {},
  config = { method: 'get' },
  otherSet = null
) => {
  let url = apiUrl
  const otherConfig = {}
  Object.assign(otherConfig, config)
  const params = postData.params || {}
  const data = postData.data || postData
  if (otherSet) {
    url = otherSet.query ? `${url}/${postData.query}` : url
  }
  // eslint-disable-next-line no-return-await
  return await ax({
    url,
    params,
    data,
    ...otherConfig
  })
}
export const REQUEST = async (methodName, params = {}) => {
  // const MyMothod: any = module
  // eslint-disable-next-line no-return-await
  return await requestFun(
    modules[methodName].apiUrl,
    params,
    {
      method: modules[methodName].method
    },
    modules[methodName].set
  )
}
